// extracted by css-extract-rspack-plugin
export default {"root":"root-d45G_P"};